import React, { Suspense } from "react";
import { Route } from "react-router-dom";

const GlanceAdjustments = React.lazy(() => import("./index"));
const GlanceAdjustmentTable = React.lazy(() => import("./glanceAdjustmentTable"));

export const useGlanceAdjustmentRoutes = () => {
  return (
    <React.Fragment>
      <Route
        path="glanceAdjustments"
        element={
          <Suspense fallback={<div>منتظر باشید...</div>}>
            <GlanceAdjustments />
          </Suspense>
        }>
        <Route
          index
          element={
            <Suspense fallback={<div>منتظر باشید...</div>}>
              <GlanceAdjustmentTable />
            </Suspense>
          }
        />
      </Route>
    </React.Fragment>
  );
};
